import { createAction } from "@reduxjs/toolkit";

export const loginTrigger = createAction("LOGIN/TRIGGER");
export const loginSuccess = createAction<string>("LOGIN/SUCCESS");
export const loginFailed = createAction<string>("LOGIN/FAILED");
export const unauthorized = createAction("UNAUTHORIZED");